import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { get } from "@/lib/api";

const SEEN = "tl_notif_toasted";
const POLL_MS = 15000;

const claim = (id) => {
  // Shared across tabs: the first tab to write the id shows the toast, the rest skip it.
  const seen = JSON.parse(localStorage.getItem(SEEN) || "[]");
  if (seen.includes(id)) return false;
  localStorage.setItem(SEEN, JSON.stringify([...seen.slice(-99), id]));
  return true;
};

export function useNotificationPoll() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const since = useRef(null);
  useEffect(() => {
    let timer;
    const tick = async () => {
      if (document.hidden) return;
      try {
        const r = await get("/notifications/unread", since.current ? { since: since.current } : {});
        since.current = r.server_time;
        qc.setQueryData(["notifications-unread"], r.unread);
        if (r.items.length) qc.invalidateQueries({ queryKey: ["notifications"] });
        r.items.filter((n) => claim(n.id)).forEach((n) =>
          toast(n.title, { id: `notif-${n.id}`, action: n.link ? { label: "View", onClick: () => nav(n.link) } : undefined }));
      } catch { /* offline or signed out: try again next tick */ }
    };
    tick();
    timer = setInterval(tick, POLL_MS);
    const onVis = () => !document.hidden && tick();
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", onVis); };
  }, [qc, nav]);
}
